import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=23099ab8&scoped=true&"
import script from "./Performance.vue?vue&type=script&lang=js&"
export * from "./Performance.vue?vue&type=script&lang=js&"
import style0 from "./Performance.vue?vue&type=style&index=0&id=23099ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23099ab8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23099ab8')) {
      api.createRecord('23099ab8', component.options)
    } else {
      api.reload('23099ab8', component.options)
    }
    module.hot.accept("./Performance.vue?vue&type=template&id=23099ab8&scoped=true&", function () {
      api.rerender('23099ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lista-vez/Performance.vue"
export default component.exports